import { render, staticRenderFns } from "./workday-add.vue?vue&type=template&id=44d133e0&"
import script from "./workday-add.vue?vue&type=script&lang=js&"
export * from "./workday-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "workday-add.vue"
export default component.exports